import { Button } from 'components';
import { memo } from 'react';
import { openMailto } from 'utils/openMailto';

import LogoSrc from '../../../../../../../assets/images/logoBudgetControl.svg';
import * as Styles from './styles';

const text =
  'Ao adquirir horas no formato de banco de horas, você pode utilizá-las de forma recorrente, simplesmente incluindo, via DPO Hub, de novas demandas, com o controle totalmente em tempo real. Além disso, os pacotes de Banco de Horas são mais vantajosos para você.';

const text2 = 'Você não possui banco de horas no momento.';

const title = 'Você já conhece nosso serviço de Pacote de Horas?';

const EmptyLayoutComponent = ({ isZero }: { isZero?: boolean }): JSX.Element => {
  return (
    <Styles.Container isZero={isZero}>
      {!isZero && <h3>{title}</h3>}
      <img src={LogoSrc} alt="logo" />

      <p
        style={{
          textAlign: isZero ? 'justify' : 'left',
          fontWeight: 500,
          fontSize: '14px',
          color: '#333333',
        }}
      >
        {isZero ? text2 : text}
      </p>

      {!isZero && (
        <Button variant="primary" onClick={() => openMailto('equipetecnologia@daniel-ip.com')}>
          Fale conosco
        </Button>
      )}
    </Styles.Container>
  );
};

export const EmptyLayout = memo(EmptyLayoutComponent);
